import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-box-outline",
  "use": "icon-box-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-box-outline\">\n    <title>icons/--icon-bg-box-outline</title>\n    <g id=\"icon-box-outline_icons/--icon-bg-box-outline\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <rect id=\"icon-box-outline_Rectangle\" stroke=\"#00519E\" x=\"0.5\" y=\"0.5\" width=\"23\" height=\"23\" rx=\"4\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol